import useSaveContent from './useSaveContent'

export default useSaveContent
